/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionseeker3Inputs */



/**
* | output |
* | --- |
* | "You can’t sit still. You love discovering new places, trying weird food, and dropping everything for spontaneous trips — it’s never boring with you." |
*
* @param {Personalityarchetypedescriptionseeker3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionseeker3 = /** @type {((inputs?: Personalityarchetypedescriptionseeker3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionseeker3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You can’t sit still. You love discovering new places, trying weird food, and dropping everything for spontaneous trips — it’s never boring with you.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No puedes quedarte quieto. Te encanta descubrir lugares nuevos, probar comida rara y dejarlo todo para hacer viajes espontáneos: contigo nunca hay aburrimiento.")
	return /** @type {LocalizedString} */ ("Ты не можешь сидеть на месте. Тебе нравится открывать новые места, пробовать странную еду и спонтанно срываться в поездки — с тобой никогда не бывает скучно.")
});
export { personalityarchetypedescriptionseeker3 as "personalityArchetypeDescriptionSeeker" }